var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBuyerManagement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5202_4617)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5202_4617)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.37141,
    cy: 5.37141,
    r: 5.37141,
    transform: "matrix(-1 0 0 1 19.3711 3)",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.60156 21.7134C4.60156 20.558 5.32785 19.5274 6.41588 19.1389V19.1389C11.3213 17.3869 16.6818 17.3869 21.5872 19.1389V19.1389C22.6752 19.5274 23.4015 20.558 23.4015 21.7134V24.1951C23.4015 25.4122 22.3235 26.3471 21.1187 26.175L17.8199 25.7037C15.2872 25.3419 12.7159 25.3419 10.1832 25.7037L6.8844 26.175C5.67954 26.3471 4.60156 25.4122 4.60156 24.1951V21.7134Z",
    stroke: "white",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5202_4617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5202_4617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0 1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBuyerManagement);
export default __webpack_public_path__ + "static/media/icon-buyer-management.91a8aa3d475ac846b0fa7d6d21c13bab.svg";
export { ForwardRef as ReactComponent };